export { Display1, Display2, Display3 } from '@sberdevices/plasma-core';
